import { icons } from "../utils/icons";
import api from "./api";
import { produce } from "immer";
import { SubNavigations } from "../utils/constants";

export default {
  namespaced: true,
  state: () => ({
    allPreferences: {
      activeSubNavigation: SubNavigations.Processes,
    },
    editableStyleId: null,
    showCutomStyles: false,
    showEditToolbox: false,
    showSettings: false,
    accessToolbarComponents: {
      1: { name: "FavoriteProcess", title: "Favorites", icon: icons.Star },
      2: { name: "Screenshot", title: "ScreenShot", icon: icons.Screenshot },
      3: { name: "ViewList", title: "Views", icon: icons.Home },
      4: { name: "DesignModeSelect", title: "Corners", icon: icons.DataView },
      5: { name: "FlowBtn", title: "Action Flow", icon: icons.ProcessFlow },
      7: { name: "Fullscreen", title: "Full Screen", icon: icons.Maximize },
      8: { name: "Copy", title: "Copy", icon: icons.Copy },
      9: { name: "Cut", title: "Cut", icon: icons.Cut },
      10: { name: "Paste", title: "Paste", icon: icons.Paste },
      11: { name: "Undo", title: "Undo", icon: icons.Undo },
      12: { name: "Redo", title: "Redo", icon: icons.Redo },
      13: { name: "Merge", title: "Merge", icon: icons.Merge },
      14: { name: "AddComment", title: "Add Comment", icon: icons.AddComment },
      15: { name: "DeleteComment", title: "Delete Comment", icon: icons.DeleteComment },
      16: { name: "Formatting", title: "Formatting", icon: icons.Palette },
      17: { name: "CustomStyles", title: "Custom Styles", icon: icons.CustomStyles },
      18: { name: "GotoToolBox", title: "Go to", icon: icons.Search },
      19: { name: "Fill", title: "Fill", icon: icons.Fill },
      20: { name: "StructureTable", title: "Structure Table", icon: icons.AddTable },
      21: { name: "FormatPainter", title: "Format Painter", icon: icons.FormatPainter },
      22: { name: "Unmerge", title: "Unmerge", icon: icons.Unmerge },
    },
    settingsActiveTab: null,
  }),
  mutations: {
    UPDATE_PREFERENCES(state, { key, value }) {
      state.allPreferences = produce(state.allPreferences, (preferences) => {
        preferences[key] = value;
      });
    },
  },
  actions: {
    async updateWithoutPersist({ commit, state, dispatch }, { key, value }) {
      commit("UPDATE_PREFERENCES", { key, value });
    },
    async update({ commit, state, dispatch }, { key, value }) {
      commit("UPDATE_PREFERENCES", { key, value });
      dispatch("persist");
    },

    toggleFavorites({ commit, state, dispatch }, { type, ids, isDelete }) {
      state.allPreferences = produce(state.allPreferences, (allPreferences) => {
        if (!allPreferences[type]) {
          allPreferences[type] = [];
        }
        const idArray = Array.isArray(ids) ? ids : [ids];
        idArray.forEach((id) => {
          allPreferences[type] =
            allPreferences[type].includes(id) || isDelete
              ? allPreferences[type].filter((x) => x !== id)
              : [...allPreferences[type], id];
        });
      });
      dispatch("persist");
      dispatch("smartSearch/loadFavorites", undefined, { root: true });
    },

    async persist({ commit, state, dispatch }) {
      try {
        await api.patch("preferences", { allPreferences: state.allPreferences });
      } catch (error) {
        console.log(error);
      }
    },
    async load({ commit, state, dispatch }) {
      try {
        state.allPreferences = { ...state.allPreferences, ...(await api.get("preferences")).data.allPreferences };
      } catch (error) {
        console.log(error);
      }
    },
    setEditableStyleId({ commit, state, dispatch }, id) {
      state.editableStyleId = id;
    },
    toggleShowCutomStyles({ commit, state, dispatch }, value) {
      state.showCutomStyles = value;
    },
    toggleShowEditToolbox({ commit, state, getters, dispatch }, value) {
      state.showEditToolbox = value;
    },
    updateStyle({ commit, state, dispatch }, { index, data }) {
      state.allPreferences.styles = produce(state.allPreferences.styles, (styles) => {
        Object.assign(styles[index], data);
      });

      dispatch("update", { key: "styles", value: state.allPreferences.styles });
      dispatch("smartSearch/loadStyles", null, { root: true });
    },
    deleteStyle({ commit, state, dispatch }, { id }) {
      state.allPreferences.styles = produce(state.allPreferences.styles, (styles) => {
        return styles.filter((style) => style.id !== id);
      });

      dispatch("update", { key: "styles", value: state.allPreferences.styles });
      dispatch("smartSearch/loadStyles", null, { root: true });
    },
    duplicateStyle({ commit, state, dispatch }, { id }) {
      state.allPreferences.styles = produce(state.allPreferences.styles, (styles) => {
        const style = styles.find((style) => style.id === id);
        styles.push({ ...style, id: styles.length + 1 });
      });
      dispatch("update", { key: "styles", value: state.allPreferences.styles });
      dispatch("smartSearch/loadStyles", null, { root: true });
    },
    setSettingActiveTab({ commit, state, dispatch }, { id }) {
      state.settingsActiveTab = id;
    },
  },
  getters: {
    activeSubNavigation: (state) => state.allPreferences?.activeSubNavigation,

    basePath: (state, getters) => {
      switch (getters.activeSubNavigation) {
        case SubNavigations.Processes:
          return "processes";
        case SubNavigations.Grids:
          return "grids";
        case SubNavigations.Businesses:
          return "businesses";
        default:
          return "processes";
      }
    },
  },
};
